// Central site content for AXION CLEANING LIMITED
export const COMPANY = {
    name: 'AXION CLEANING',
    legal: 'Axion Cleaning Limited',
    tagline: 'Cleaning you can rely on — Bristol & surrounding areas.',
    email: 'info@axioncleanlimited.com',
    phone: '+447947773969',
    phoneDisplay: '07947 773969',
    whatsapp: '447947773969',
    whatsappMessage: "Hi AXION — I'd like to ask about cleaning services.",
    region: 'Bristol & surrounding areas',
    hours: 'Mon–Sat · 7:00 – 19:00',
};

export const NAV_LINKS = [
    { to: '/', label: 'Home', testid: 'nav-link-home' },
    { to: '/services', label: 'Services', testid: 'nav-link-services' },
    { to: '/about', label: 'About', testid: 'nav-link-about' },
    { to: '/contact', label: 'Contact', testid: 'nav-link-contact' },
];

export const SERVICES = [
    {
        slug: 'domestic',
        title: 'Domestic Cleaning',
        kicker: '01 / Residential',
        summary: 'Weekly, fortnightly or one-off — meticulous home care delivered by vetted, uniformed teams.',
        bullets: ['Kitchens & bathrooms detailed', 'Eco-friendly products', 'Same cleaner each visit'],
        image: 'https://images.unsplash.com/photo-1756199617913-620d64edb8a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxwcmlzdGluZSUyMG1pbmltYWxpc3QlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc3NzY0NTE5NXww&ixlib=rb-4.1.0&q=85',
        testid: 'service-card-domestic',
    },
    {
        slug: 'commercial',
        title: 'Commercial Cleaning',
        kicker: '02 / Office & retail',
        summary: 'Quietly thorough out-of-hours cleans for studios, offices and clinics across Bristol.',
        bullets: ['Out-of-hours scheduling', 'COSHH compliant', 'Dedicated supervisor'],
        image: 'https://images.unsplash.com/photo-1623679116710-78b05d2fe2f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBkZXNrfGVufDB8fHx8MTc3NzY0NTE5NXww&ixlib=rb-4.1.0&q=85',
        testid: 'service-card-commercial',
    },
    {
        slug: 'deep',
        title: 'Deep Cleaning',
        kicker: '03 / Restorative',
        summary: 'A floor-to-ceiling reset for tired homes — limescale, grout, behind appliances and more.',
        bullets: ['Steam & detail tools', 'Inside oven & fridge', 'Skirting & light fittings'],
        image: 'https://static.prod-images.emergentagent.com/jobs/e4a64253-1671-4f6b-b151-a03250450170/images/4a808cde351e565c660b39a8fe843db76e243fa9d446631eaf07a5fa6c472b95.png',
        testid: 'service-card-deep',
    },
    {
        slug: 'tenancy',
        title: 'End of Tenancy',
        kicker: '04 / Move-out',
        summary: 'Deposit-back guarantee. Hardcore scrubbing of kitchens, ovens, grout and every hidden corner — inventory-clerk approved.',
        bullets: ['Agency-grade checklist', 'Free re-clean within 48h', 'Oven, hob & extractor degreased'],
        image: 'https://customer-assets.emergentagent.com/job_axion-clean-premium/artifacts/qaiqggaq_ChatGPT%20Image%20May%201%2C%202026%2C%2005_07_22%20PM.png',
        imageStyle: { transform: 'scale(1.85)', transformOrigin: '20% 30%' },
        testid: 'service-card-tenancy',
    },
    {
        slug: 'airbnb',
        title: 'Airbnb Turnaround',
        kicker: '05 / Hospitality',
        summary: 'Hotel-grade turnarounds with linen, restocking and 5-star presentation in under 4 hours.',
        bullets: ['Linen swap & laundry', 'Welcome-pack restock', 'Photo report after each clean'],
        image: 'https://images.unsplash.com/photo-1588796460666-590f1d712a2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBiZWRyb29tfGVufDB8fHx8MTc3NzY0NTIwOHww&ixlib=rb-4.1.0&q=85',
        testid: 'service-card-airbnb',
    },
];

export const TRUST_BADGES = [
    { label: 'Fully Insured', sub: '', icon: 'ShieldCheck' },
    { label: 'Vetted Cleaners', sub: 'trained in-house', icon: 'BadgeCheck' },
    { label: 'Eco-Friendly', sub: 'low-tox products', icon: 'Leaf' },
    { label: 'Bristol-based', sub: 'BS1 — BS41', icon: 'MapPin' },
    { label: '24h Re-clean', sub: 'guarantee', icon: 'Star' },
];

export const FAQS = [
    {
        q: 'Which areas of Bristol do you cover?',
        a: 'We serve all BS postcodes including Clifton, Redland, Cotham, Bedminster, Southville, Bishopston, Stokes Croft, Westbury-on-Trym, Henleaze and most surrounding villages within 12 miles of central Bristol.',
    },
    {
        q: 'Are your cleaners insured?',
        a: 'Yes — every Axion cleaner is fully employed by us, trained in-house, and we carry comprehensive public liability and employer liability insurance on every job.',
    },
    {
        q: 'Do you bring your own products and equipment?',
        a: 'Absolutely. We arrive with eco-friendly, low-tox products, microfibre kits, HEPA-filter vacuums and steam tools — you only need to point us at the kettle.',
    },
    {
        q: 'How quickly can you start?',
        a: 'For most regular cleans we can begin within 24–48 hours. End-of-tenancy and deep cleans we can usually slot in within 24–48 hours too.',
    },
    {
        q: 'What if I\'m not happy with the clean?',
        a: 'We offer a 24-hour re-clean guarantee on every booking. If anything is missed, send a photo and we will return free of charge.',
    },
    {
        q: 'Do I need to be home during the clean?',
        a: 'Not at all — most regular clients leave us a key or smart-lock code. We log every key carefully and store them in a numbered safe at our office.',
    },
];

export const STATS = [
    { value: '2,400+', label: 'Cleans completed' },
    { value: '5★', label: 'Service rating' },
    { value: '< 1 hr', label: 'Quote response' },
    { value: '100%', label: 'Deposit success' },
];

// Hero: AXION cleaning team — professional cleaners in branded mint/green polos in action
export const HERO_IMAGE = 'https://customer-assets.emergentagent.com/job_axion-clean-premium/artifacts/0l9e08p9_ChatGPT%20Image%20May%201%2C%202026%2C%2005_00_34%20PM.png';
// Team-in-action image for About page
export const ABOUT_IMAGE = 'https://images.pexels.com/photos/6196680/pexels-photo-6196680.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400';

// Bristol postcodes & neighbourhoods we cover
export const SERVICE_AREAS = [
    'Clifton', 'Redland', 'Cotham', 'Bedminster', 'Southville', 'Bishopston',
    'Westbury-on-Trym', 'Henleaze', 'Stokes Croft', 'Easton', 'St. Werburghs',
    'Long Ashton', 'Portishead', 'Keynsham', 'Nailsea', 'Yate',
];

// Real before/after photos from completed Axion jobs
export const REAL_BEFORE_AFTER = [
    {
        image: 'https://customer-assets.emergentagent.com/job_axion-clean-premium/artifacts/kcjt39nl_2B1712B9-AD72-4013-83D7-6C9B37923D6A.png',
        caption: 'Oven · burnt-on grease to spotless',
        aspect: 'aspect-square',
    },
    {
        image: 'https://customer-assets.emergentagent.com/job_axion-clean-premium/artifacts/zoo4lzc3_B9F802A2-0ECF-4317-BF8C-BBB36F0084CC.png',
        caption: 'Bathroom deep clean · sink & shower',
        aspect: 'aspect-square',
    },
    {
        image: 'https://customer-assets.emergentagent.com/job_axion-clean-premium/artifacts/x9p5mv5w_63CADF3F-DF86-42EA-9908-0A8BB888AB75.png',
        caption: 'Shower fixtures · limescale removed',
        aspect: 'aspect-square',
    },
    {
        image: 'https://customer-assets.emergentagent.com/job_axion-clean-premium/artifacts/kisjb1pj_949F628E-DC1A-4E6E-8EDE-246B32658450.png',
        caption: 'Shower cubicle · grime to gleaming',
        aspect: 'aspect-square',
    },
];
